import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const medianDescription: CalculatorDescription = {
  id: CalculatorId.MEDIAN,
  title: 'Median Calculator',
  metaTitle: 'Online Median Calculator - Find the Middle Value',
  description: 'Calculate the median of your data set. The median is the middle value that separates the higher half from the lower half of your data.',
  metaDescription: 'Calculate median online. Find the central value of your data with our free median calculator. Statistical analysis made easy.',
  howTo: {
    title: 'How to Calculate Median',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically display the median value',
      'View how your data is distributed around the median in the visualization'
    ]
  },
  examples: [
    {
      title: 'Price Analysis',
      description: 'Find the middle price point in a set of product prices.',
      dataDescription: 'A dataset of 10 product prices ranging from $22 to $40.',
      insights: [
        'Median is less affected by extreme values than mean',
        'Half of the values fall below the median',
        'Half of the values fall above the median',
        'Compare with mean to understand skewness'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.MEAN,
    CalculatorId.FIVE_NUMBER_SUMMARY,
    CalculatorId.INTERQUARTILE_RANGE
  ]
}; 